module.exports = __webpack_public_path__ + "static/media/pw-points-icon.5461080e.svg";